import { render } from "./ManageProviders.vue?vue&type=template&id=11f641cb"
import script from "./ManageProviders.vue?vue&type=script&lang=js"
export * from "./ManageProviders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__